
import { Component, OnInit } from '@angular/core';
import { AnnotationStreamManagementV2 } from './annotation-stream-management.service';
import { isNumeric } from 'rxjs/util/isNumeric';
import { ISubscription } from "rxjs/Subscription";
import { NotificationService } from "../../services/notification.service";
import { TenantRetrieverService } from "../../services/tenant-Retriever.service";

@Component({
    selector: 'mainannotationstreammanagementv2',
    template: require('./annotation-stream-management.component.html')
})

export class AnnotationStreamManagementComponentV2 implements OnInit{
    systemGuid: string;
    printHtml: string;
    textBoxInput: string;
    tenantName: string;
    tenantNameList : string[];
    errorInFetchingTenantNames: boolean = true;
    guidValidatorRegex = new RegExp("^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$");
    
    responseData: any;

    constructor(private annotationStreamManagement: AnnotationStreamManagementV2, private notifier: NotificationService, private tenantRetriever: TenantRetrieverService) {
        this.notifier.clear();
    }
    clearMessages() {
        this.notifier.clear();
    }

    ngOnInit(): void {
        this.getTenantNames();
    }

    getTenantNames() {
        this.notifier.displayInfo("Fetching Tenant Names ...");
        this.tenantRetriever.getTenant().subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processGetTenantResponse();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            }
        );
    }

    processGetTenantResponse() {

        if (this.responseData.statusCode === 200) {
            this.tenantNameList = this.responseData.data;
            this.tenantName = this.tenantNameList[0];
            this.errorInFetchingTenantNames = false;
        } else {
            this.errorInFetchingTenantNames = true;
            this.notifier.displayError("Unable to fetch Tenant names");
        }
    }

    annotationStreamBySystemGuid() {
        this.clearMessages();
        if (!this.guidValidatorRegex.test(this.systemGuid)) {
            this.notifier.displayError('Please enter a valid system Guid');
            return;
        }
        this.notifier.displayInfo("Fetching annotation stream details... Please wait");
        this.annotationStreamManagement.annotationStreamsBySystemGuid(this.systemGuid, this.tenantName).subscribe(
            resp => {
                this.clearMessages();
                if (resp.statusCode === 200) {
                    this.responseData = resp.data;
                    this.notifier.displaySuccess("Successfully initiated annotation streams details persistence " + this.responseData);
                } else {
                    this.notifier.displayError(resp.message as string);
                }
            },
            error => {
                this.clearMessages();
                this.notifier.displayError((error.statusCode !== 0) ? error.data as string : 'server error');
            });
    }    

    initializetab() {
        this.clearMessages();
    }

    prettyPrint(jsonObject:any) {
        return JSON.stringify(jsonObject, null, 2).replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
    }

    processAnnotationStreamResponse(resp: any, errorMessage: any) {
        this.clearMessages();
        if (resp.statusCode === 200) {
            this.responseData = resp.data;
            this.notifier.displaySuccess(errorMessage);
        } else {
            this.notifier.displayError(resp.message as string);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/annotationStreamManagementV2/annotation-stream-management.component.ts
 **/